"use strict";

exports.__esModule = true;
exports.GRAY_DARK = exports.WHITE = exports.GREEN = exports.BLUE = exports.RED = void 0;
var RED = '#f44';
exports.RED = RED;
var BLUE = '#1989fa';
exports.BLUE = BLUE;
var GREEN = '#4b0';
exports.GREEN = GREEN;
var WHITE = '#fff';
exports.WHITE = WHITE;
var GRAY_DARK = '#969799';
exports.GRAY_DARK = GRAY_DARK;


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/utils/color.js
// module id = 81
// module chunks = 1